// extracted by mini-css-extract-plugin
export default {"reportingEvents":"AuditLogs_reportingEvents__JJlEp","table":"AuditLogs_table__irX6W"};